// extracted by mini-css-extract-plugin
module.exports = {"arrow_back":"OrderBackArrow_arrow_back__00jJd"};